import { render, staticRenderFns } from "./MessageBoxModal.vue?vue&type=template&id=225ccdd0&scoped=true&"
import script from "./MessageBoxModal.vue?vue&type=script&lang=js&"
export * from "./MessageBoxModal.vue?vue&type=script&lang=js&"
import style0 from "./MessageBoxModal.vue?vue&type=style&index=0&id=225ccdd0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225ccdd0",
  null
  
)

export default component.exports